export default {
    data() {
        return {
            form: {
                examchoose: [],
                examchoose2: [],
                email: '',
                name: '',
                age: '',
                phone: '',
                confirmPhone: '',
                step: 1, // Step 0. chọn đăng nhập tài khoản
                level: 2,
                class: '',
                school: ''
            },
        }
    },
    computed: {
        
        error() {
            return this.$TestApp.getError()
        },
        
    },
    methods: {
        logout() {
            this.form.step = 0;
            this.$TestApp.userClearInfo()
        },
        ChangeStep(step) {
            this.form.step = step
        }
    },
}